export const clearDoubleSpaces = (value) => {
    if (typeof value !== "string")
        return value;
    let t = value.trim();
    while (t.includes('  '))
        t = t.replace("  ", " ");
    return t;
};
